<template>
  <div class="main-left">

    <el-menu default-active="/baseservice" class="el-menu-vertical-demo" :router="true">

      <!-- <el-menu-item index="/baseservice" :class="{'isActive': active}">
        <i class="el-icon-menu"></i>
        基础业务</el-menu-item> -->

      <el-menu-item :index="item.path" v-for="item in list" ><i class="el-icon-menu"></i>{{item.name}}</el-menu-item>

    </el-menu>

  </div>
</template>
<script type="text/javascript">
  import $ from 'jquery'

  export default {
    name:'main-nav',
    data: function(){
      return {
        active:true,
        list:[]
      }
    },
    methods: {
      request: function(){
        var vm = this
        // $.ajax({
        //   type:'get',
        //   url:"http://localhost:3000/api",
        //   success:function(re){
        //     vm.list = re.type.list.data
        //   }
        // })
        vm.list = [

          {
            name:'基础业务',
            path :'/baseservice'
          },
          {
            name:'小贷业务系统',
            path :'/imfbpXd'
          },
          {
            name:'融资租赁系统',
            path :'/imfbpRz'
          },
          {
            name:'流程中心',
            path :'/bmp'
           }
          ]

      }
    },
    created: function(){
      this.request()
    },
    watch: {
       '$route': function (to,from) {
           if(to.path == '/activePublic'){
               this.active = true ;
           }else if(to.path == '/activeManage'){
               this.active = false ;
           }
       }
    }
  }
</script>
<style>
main .main-left{background-color: #3a3f51; position: relative;height: 100%; overflow-y: auto;width: 125px;float: left}
/*main .main-left{-webkit-box-flex: 0;-ms-flex: 0 0 70px;flex: 0 0 70px;background-color: rgb(58, 63, 81);}*/
main .el-menu{background-color: transparent!important;}
.el-menu-item{ font-size: 13px; color: #b4b6bd;border-left: 2px #3a3f51 solid}
.el-menu-item li{}
.el-menu-item {padding: 0 10px !important;}
.el-menu-item:hover{border-left: 2px #ff0000 solid; background: none!important;}
</style>



// WEBPACK FOOTER //
// mainNav.vue?507980fa